import { useCallback } from 'react';
import useToastService from './useToastService';

/**
 * Hook that provides a function to copy data to clipboard with toast notifications.
 * Supports custom formatting via the formatter parameter.
 * 
 * @returns A function that copies data to clipboard
 */
export function useCopyToClipboard() {
    const toast = useToastService();

    return useCallback(
        async (data: unknown, formatter: (data: unknown) => string = (d) => JSON.stringify(d, null, 2)) => {
            try {
                const text = formatter(data);
                await navigator.clipboard.writeText(text);
                toast.success('Copied to clipboard');
            } catch {
                toast.error('Failed to copy to clipboard');
            }
        },
        [toast]
    );
}
